import { buildChildModule } from '@/app/arch/components/crud/CrudRouter';
import reversalBreadcrumps from '../reversalBreadcrumps';

export default [
  ...buildChildModule({
    name: 'billPayment',
    path: 'bill-payment',
    moduleActive: 'contacard',
    subModuleActive: 'reversal',
    card: {
      title: 'Pagamento de conta',
      icon: '',
    },
    breadcrumbs: [
      ...reversalBreadcrumps,
      {
        text: 'Pagamento de contas',
        disabled: false,
        to: 'billPayment.list',
      },
    ],
    listRoute: {
      filterComponent: () => import('Modules/contacard/reversal/bill-payment/BillPaymentFilters.vue'),
      pageContent: () => import('Modules/contacard/reversal/bill-payment/BillPaymentList.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar', searchAttribute: 'search' },
      pageTitle: 'Estorno de pagamento de contas',
      navigateBackRoute: 'produto',
    },
    editRoute: {
      component: () => import('App/modules/contacard/reversal/bill-payment/BillPaymentForm.vue'),
      breadcrumbs: [
        {
          text: 'Visualizar pagamento de conta',
          disabled: true,
        },
      ],
    },
  }),
];
